import React from "react";
import SEO from "../../elements/SEO";
import AppliedJobList from "../../molecules/appliedJobs/list";
import Layout from "../layout/layout";

import '../layout/styles.scss';

const AppliedJobPage = ({...props}) => {
  return (
    <>
      <Layout>  
        <SEO title="Applied Jobs" />
        <AppliedJobList {...props} />
      </Layout>
    </>
  );
};

export default AppliedJobPage;
